import { render, staticRenderFns } from "./SubCategoriasMesa.vue?vue&type=template&id=45477ebb&scoped=true&"
import script from "./SubCategoriasMesa.vue?vue&type=script&lang=js&"
export * from "./SubCategoriasMesa.vue?vue&type=script&lang=js&"
import style0 from "./SubCategoriasMesa.vue?vue&type=style&index=0&id=45477ebb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45477ebb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VImg,VRow})
